$( document ).ready(function() {

    if (window.matchMedia("(max-width: 640px)").matches) {
        $('#simulator-iframe .select-wrapper').slick({
            dots: false,
            infinite: false,
            slidesToShow: 2,
            slidesToScroll: 1,
            initialSlide: 1,
        });
    }
});
